import { useEffect, useState, useRef } from "react";

export function useAnimatedNumber(realValue, options = {}) {
  const { duration = 1000, boost = 0 } = options;

  const target = realValue + boost;

  const [display, setDisplay] = useState(0);
  const rafRef = useRef();

  useEffect(() => {
    let start = null;

    function animate(ts) {
      if (!start) start = ts;

      const progress = Math.min((ts - start) / duration, 1);

      // smooth ease-out
      const eased = 1 - Math.pow(1 - progress, 3);
      const next = target * eased;

      setDisplay(Math.floor(next));

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        setDisplay(target); // snap clean at end
      }
    }

    rafRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafRef.current);
  }, [target]);

  return display;
}
